<script setup>
const route = useRoute();
const { $get } = useAxios();

const { data: albums, pending: isLoaded } = await useAsyncData(
  "get all videos",
  () => $get("/api/v3/videos")
);

useHead({
  title: "РУСДРАМ",
  meta: [
    {
      hid: "title",
      property: "title",
      content: "РУСДРАМ",
    },
    {
      hid: "og:title",
      property: "og:title",
      content: "РУСДРАМ",
    },
    {
      hid: "description",
      name: "description",
      content:
        "Медиа | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "og:description",
      property: "og:description",
      content:
        "Медиа | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "url",
      name: "url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "og:url",
      property: "og:url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "image",
      name: "image",
      content: "https://rusdram.org/rusdram.jpg",
    },
    {
      name: "og:image",
      property: "og:image",
      content: "https://rusdram.org/rusdram.jpg",
    },
  ],
});
</script>

<template>
  <nuxt-layout name="default">
    <div v-if="!isLoaded">
      <r-section v-if="albums">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-7" v-if="albums.length">
          <router-link
            v-for="album in albums"
            :key="album._id"
            :to="`/media/videos/${album._id}`"
          >
            <div
              class="h-60 xl:h-85 overflow-hidden relative rounded-lg bg-black"
            >
              <img
                loading="lazy"
                :src="album.photo"
                :alt="album.name"
                class="w-full h-full object-cover transform-gpu transition-all duration-300 opacity-80 hover:opacity-60"
              />
              <div class="absolute bottom-4 left-9 right-9 z-10">
                <h2 class="text-white mt-auto text-lg2">{{ album.name }}</h2>
              </div>
            </div>
          </router-link>
        </div>
      </r-section>
    </div>
    <r-full-page-pro-loader v-else></r-full-page-pro-loader>
  </nuxt-layout>
</template>

<style scoped>
img.object-cover {
  position: absolute;
  left: 0%;
  top: 0%;
  width: 100%;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  transition: 0.3s;
  max-width: 100vw;
}
img.object-cover:hover {
  position: absolute;
  width: 110%;
  height: 110%;
  min-width: 110%;
  min-height: 110%;
  left: -5%;
  top: -5%;
}
</style>
